import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-forecast-for-receipt-modal-content__main-content main-content" }
const _hoisted_2 = { class: "main-content__container" }
const _hoisted_3 = { class: "main-content__title" }
const _hoisted_4 = { class: "main-content__select-output-range-picker--container select-output-range-picker__container" }

import { i18n } from '@/i18n';
import { computed, ref } from 'vue';
import { watch } from 'vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { ForecastForReceiptFormState } from '@/customerForecastModule/domains/entities/ForecastForReceiptMenu';
import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { FilterType } from '@/coreDomainsModule/entities/filter';
import { MAX_OF_DISPLAY_FORECAST_MONTH, MIN_OF_DISPLAY_FORECAST_MONTH } from '@/customerForecastModule/constants';
import { DateService } from '@/coreDomainsModule/services/dateService';
import MultipleUserSelectInput from '@/corePagesModule/user/SelectInput/MultipleUserSelectInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateForecastForReceiptModal',
  props: {
    modalState: { type: Boolean },
    selectInputIndex: {},
    targetForecastForReceiptId: {},
    currentForecastForReceiptFormState: {}
  },
  emits: ["close", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

//変数
const t = i18n.t;

const currentFilterType = ref<FilterType | undefined>(undefined);

const rangeSelectInputData = ref<string[]>(DateService.getMonthRangeList(MIN_OF_DISPLAY_FORECAST_MONTH, MAX_OF_DISPLAY_FORECAST_MONTH));

// 更新を行う受領用内示情報
const newForecastForReceiptInfo = ref<ForecastForReceiptFormState>({
  forecastForReceiptName: props.currentForecastForReceiptFormState.forecastForReceiptName,
  forecastForReceiptResponsibleUserIdList: props.currentForecastForReceiptFormState.forecastForReceiptResponsibleUserIdList,
  outputRange: props.currentForecastForReceiptFormState.outputRange,
});

/**
 * モーダル内の出力範囲設定項目の初期選択値の決定を行う
 */
const selectedOutputRangeValueIndex = computed(() => {
  const targetIndex = rangeSelectInputData.value.findIndex((item) => item === newForecastForReceiptInfo.value.outputRange + t('months'));
  if (targetIndex === -1) {
    return 0;
  } else {
    return targetIndex;
  }
});

watch(
  () => props.modalState,
  (newVal) => {
    if (newVal) {
      newForecastForReceiptInfo.value = {
        forecastForReceiptName: props.currentForecastForReceiptFormState.forecastForReceiptName,
        forecastForReceiptResponsibleUserIdList: props.currentForecastForReceiptFormState.forecastForReceiptResponsibleUserIdList,
        outputRange: props.currentForecastForReceiptFormState.outputRange,
      };
    }
  }
);

watch(
  () => i18n.locale,
  () => {
    // i18nの言語が変更されたときに、出力範囲の選択肢を再生成する
    rangeSelectInputData.value = DateService.getMonthRangeList(MIN_OF_DISPLAY_FORECAST_MONTH, MAX_OF_DISPLAY_FORECAST_MONTH);
  }
);

const isDisabledApplyButton = computed((): boolean => {
  return (
    newForecastForReceiptInfo.value.forecastForReceiptName == null ||
    newForecastForReceiptInfo.value.forecastForReceiptName === '' ||
    newForecastForReceiptInfo.value.outputRange == null ||
    (newForecastForReceiptInfo.value.outputRange <= MIN_OF_DISPLAY_FORECAST_MONTH &&
      newForecastForReceiptInfo.value.outputRange > MAX_OF_DISPLAY_FORECAST_MONTH)
  ); // この条件は一応で入れてる;
});

/**
 * 範囲選択のセレクトインプットで選択された値を取得する
 * @param index - 選択された値のインデックス
 */
const onSelectedRangeValue = (index: number) => {
  const selectedRange = rangeSelectInputData.value[index];
  // 文字列から数字のみを抽出
  const rangeValue = selectedRange.replace(/[^0-9]/g, '');
  newForecastForReceiptInfo.value.outputRange = Number(rangeValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('保存'),
    "modal-width": 764,
    "is-disabled-next-button": isDisabledApplyButton.value,
    onOnBack: _cache[4] || (_cache[4] = ($event: any) => (emits('close'))),
    onOnNext: _cache[5] || (_cache[5] = ($event: any) => (emits('apply', newForecastForReceiptInfo.value)))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('受領用内示名の編集')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('編集する受領用内示名を選択し、新しい受領用内示名で保存してください。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('受領用内示名を編集')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newForecastForReceiptInfo.value.forecastForReceiptName) = $event)),
            type: "text",
            class: "main-content__input"
          }, null, 512), [
            [_vModelText, newForecastForReceiptInfo.value.forecastForReceiptName]
          ]),
          _createVNode(MultipleUserSelectInput, {
            "select-input-index": _ctx.selectInputIndex,
            "original-selected-user-id-list": props.currentForecastForReceiptFormState.forecastForReceiptResponsibleUserIdList,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (newForecastForReceiptInfo.value.forecastForReceiptResponsibleUserIdList = $event))
          }, null, 8, ["select-input-index", "original-selected-user-id-list"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SelectInput, {
              class: "select-output-range-picker__end-month",
              index: _ctx.selectInputIndex + 2,
              "model-value": rangeSelectInputData.value[selectedOutputRangeValueIndex.value],
              placeholder: '',
              label: _unref(t)('出力する月数'),
              "filter-type": 'DISPLAY_YEAR_MONTH',
              "use-reset": false,
              "prop-options": rangeSelectInputData.value,
              "is-open-prop": currentFilterType.value === 'DISPLAY_YEAR_MONTH',
              "use-search-input": false,
              "onClick:selectInput": _cache[2] || (_cache[2] = () => (currentFilterType.value = 'DISPLAY_YEAR_MONTH')),
              "onUpdate:valueWithIndex": _cache[3] || (_cache[3] = (_, index) => onSelectedRangeValue(index))
            }, null, 8, ["index", "model-value", "label", "prop-options", "is-open-prop"])
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})